import { IonToggle } from "@ionic/react";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { type AnyFieldApi } from "@tanstack/react-form";
import { cx } from "@/lib/style/cva.config";
import { getErrorText } from "./utils";

export type FormToggleProps = {
  field: AnyFieldApi;
};

export const FormToggle = forwardRef<
  HTMLIonToggleElement,
  React.ComponentProps<typeof IonToggle> & FormToggleProps
>(function FormToggle({ field, ...props }, ref) {
  const { i18n } = useTranslation();

  return (
    <IonToggle
      ref={ref}
      name={field.name}
      // @ts-expect-error It should exist: https://ionicframework.com/docs/api/toggle#errortext
      errorText={getErrorText({ language: i18n.language, errors: field.state.meta.errors })}
      checked={field.state.value}
      onIonChange={(event) => field.handleChange(event.detail.checked)}
      onIonBlur={field.handleBlur}
      readonly={field.state.meta.isValidating || field.form.state.isSubmitting}
      {...props}
      className={cx(
        field.state.meta.isTouched && "ion-touched",
        !!field.state.meta.errors && field.state.meta.errors.length > 0 && "ion-invalid",
        props.className,
      )}
    />
  );
});
